import React from "react";

const Career = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Career</h1>
    </div>
  );
};

export default Career;
